export default "__VITE_ASSET__CJH5Z4hx__"